import React from 'react';
import {IntlProvider} from 'react-intl';
import {messages} from '../../translations/transaltionMessages';
import * as PropTypes from 'prop-types';
import {countryInfo} from '../ESignature/Constants/constants';

export const TranslationWrapper = ({branchCode, children}) => {
    const locale = branchCode && branchCode.slice(0, 2);
    const countryCode = locale && countryInfo[locale].locale;

    return (
        branchCode ?
            <IntlProvider
                locale={locale}
                messages={messages[countryCode]}
            >
                {children}
            </IntlProvider> :
            null
    );
}

TranslationWrapper.propTypes = {
    branchCode: PropTypes.string,
    children: PropTypes.node.isRequired
};
